// §4.4 partial — dashboard routes. The composer auto-collects this into
// routes.generated.ts. `/dashboard` stays available for the admin/dashboard
// skeleton; user root `/` is owned by the IA Core robot route.
// P0-52: `/history` was navigated to by DashboardHeader but had no registered
// route → 404. Added here; legacy DEV used `/?tab=historico` query-param tabs
// but v2 migrated to a dedicated `/history` page with its own tabs.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const DashboardLayout = lazyWithRetry(() => import("./pages/DashboardLayout"));
const DashboardPage = lazyWithRetry(() => import("./pages/DashboardPage"));
const HistoryPage = lazyWithRetry(() => import("./pages/HistoryPage"));

const routes: RouteObject[] = [
  {
    Component: DashboardLayout,
    children: [
      { path: "/dashboard", Component: DashboardPage },
      { path: "/history", Component: HistoryPage },
    ],
  },
];

export default routes;
